<template>
  <div class="toast-container">
    <b-alert
      v-if="alertHasContent"
      @dismissed="closeAlert"
      dismissible
      :show="alert.visible"
      :variant="alert.type"
    >
      {{ alert.msg }}
    </b-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BaseAlert',
  computed: {
    ...mapGetters([
      'alert',
      'alertHasContent'
    ])
  },
  methods: {
    ...mapActions([
      'setAlertData'
    ]),
    closeAlert () {
      this.setAlertData(null)
    }
  }
}
</script>
